import React from 'react';

import './style.sass';

const CommonUsualText = ({ className = '', children = '' }) => {
    return <div className={`common__text-usual ${className}`}>{children}</div>;
};

export default CommonUsualText;
